<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div class="tw-mb-2">
    <legend>
      {{ $t('Select your business entity type') }}
    </legend>

    <WdsRadioGroup v-model:checked="internalModelValue" name="business_entity">
      <WdsRadio :disabled="disabled" value="limited">
        <i class="input-helper"></i>
        {{ $t('Limited Company (PSC)') }}
        <br />
        <span class="c-gray small">
          {{ $t('E.g. if you have a Personal Service Company setup.') }}
        </span>
      </WdsRadio>

      <WdsRadio :disabled="disabled" value="sole_trader">
        <i class="input-helper"></i>
        {{ $t('Registered Sole Trader') }}
        <br />
        <span class="c-gray small">
          {{ $t('If you have a Sole Trader business setup with HMRC.') }}
        </span>
      </WdsRadio>

      <WdsRadio disabled value="umbrella">
        <i class="input-helper"></i>
        {{ $t('Umbrella company') }}
        <br />
        <WdsText small>
          {{
            $t(
              'New hires via umbrella companies are no longer supported. Update your setup to continue receiving hiring offers.',
            )
          }}
        </WdsText>
        <a
          href="https://help.worksome.dk/en/articles/4150201-umbrella-engagements-no-longer-available"
          target="_blank"
          class="tw-underline"
        >
          {{ $t('Learn more about your options →') }}
        </a>
      </WdsRadio>

      <WdsRadio :disabled="disabled" value="no_setup">
        <i class="input-helper"></i>
        {{ $t('No setup yet') }}
        <br />
        <span class="c-gray small">
          {{ $t('If you are not working through a business') }}
        </span>
      </WdsRadio>
    </WdsRadioGroup>
  </div>
</template>

<script>
import { WdsRadio, WdsRadioGroup, WdsText } from '@worksome/wds-components'
import { computed } from 'vue'

export default {
  components: {
    WdsText,
    WdsRadio,
    WdsRadioGroup,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const internalModelValue = computed({
      get() {
        return props.modelValue
      },
      set(modelValue) {
        emit('update:modelValue', modelValue)
      },
    })
    return {
      internalModelValue,
    }
  },
}
</script>
